module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_4.7632e2a9.jpg";